import {BaseAppModel} from "./AppModel";
import Product from "@/model/Product";
import Category from "@/model/Category";
import ThirdThingProperty from '@/module/thing/ThirdThingProperty';

export default class ThingPropertyMapping extends BaseAppModel<ThingPropertyMapping> {
    category?: Category = undefined
    categoryId?: number = undefined
    product?: Product = undefined
    productId?: number = undefined
    identifier!: string
    tmallProp = new ThirdThingProperty()
}
